module.exports = __webpack_public_path__ + "static/media/20.5f044a0f.jpg";